"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AoMesher_1 = require('./AoMesher');
var R_MASK = 0xff0000;
var G_MASK = 0x00ff00;
var B_MASK = 0x0000ff;
var PaletteAoMesher = (function (_super) {
    __extends(PaletteAoMesher, _super);
    function PaletteAoMesher() {
        _super.call(this, false);
    }
    PaletteAoMesher.prototype.build = function (gl, padded, palette) {
        this.palette = palette;
        var vao = this.createVao(gl, padded);
        this.palette = null;
        return vao;
    };
    PaletteAoMesher.prototype.getVertexData = function (data, val) {
        var c = this.palette[val];
        data[0] = (c & R_MASK) >> 16;
        data[1] = (c & G_MASK) >> 8;
        data[2] = (c & B_MASK) >> 0;
    };
    return PaletteAoMesher;
}(AoMesher_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PaletteAoMesher;
//# sourceMappingURL=PaletteAoMesher.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/meshers/PaletteAoMesher.js
 ** module id = 934
 ** module chunks = 0
 **/